import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { PolicyEngineMenuModule } from './policy-engine-menu/policy-engine-menu.module';
import { PolicyManagementModule } from './policy-management/policy-management.module';
import { RulesManagementModule } from '@app/authorized/policyEngine/rules-management/rules-management.module';
import { PolicyEnforcementModule } from '@app/authorized/policyEngine/policy-enforcement/policy-enforcement.module';

@NgModule({
    imports: [
        SharedModule,
        PolicyEngineMenuModule,
        PolicyManagementModule,
        RulesManagementModule,
        PolicyEnforcementModule
    ],
    declarations: [],
    entryComponents: [],
    exports: []
})
export class PolicyEngineModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/policyEngine/policy-engine.module.ts